const data1 = [
  {
    status: "Pending",
    id: 1,
    dataset: {
      gender: "Male",
      workExp1: "Municipality of Bansalan",
      workExp2: "Office Staff",
      workExp3: "encode documents",
      workExp4: "paper works",
      workExp11: "KRZ Systems Incoporated",
      workExp21: "Technical Staff",
      workExp31: "take calls",
      workExp41: "troubleshoot",
      workExp51: "entertain client's concern/s",
      cs1: "PRC-ID",
      otherInfo:
        "Interested and qualified applicants should signify their interest in writing. Attach the following documents to the application letter and send to the address below not later than May 06, 2023",
      posTitle: "Jaco Raven Miras",
      placeAssign: "Villa Donieza St.",
      address: "Tubod.",
      address1: "Bansalan",
      address2: "Davao Del Sur",
      elementary: "VILLA DONEZA CENTRAL ELEMENTARY SCHOOL",
      secondary: "MARBER NATIONAL HIGH SCHOOL",
      college: "SPAMAST ",
      salary: "19",
      monthlySalary: "Baha",
      eligibility: "RA. 1080",
      education: "Masters of Arts",
      training: "Five (5) years of relevant experience + VS Perfomance Rating",
      competency:
        "Delivering Efficient Results ? Personal Effectiveness ? Has  Community-Based Action Research and Published   Research ? Participated in Civic Welfare Service ? Proficient in Oral and Written Communication ? Teaching Skills ? Detailed Oriented ? Computer Literate",
      instruction:
        "Interested and qualified applicants should signify their interest in writing. Attach the following documents to the application letter and send to the address below not later than May 06, 2023.",
      document1:
        "1. Fully accomplished Personal Data Sheet (PDS) with recent passport-sized picture (CS Form No. 212, Revised 2017) which can be downloaded at www.csc.gov.ph;",
      document2:
        "2. Performance rating in the present position for one (1) year (if applicable);",
      document3:
        "3. Photocopy of certificate of eligibility/rating/license; and",
      document4: "4. Photocopy of Transcript of Records.",
      qualifiedApplicants:
        "are advised to hand in or send through courier/email their application to:",
      employerName: "PBGEN FERDINANDO G SEVILLA (Ret), MPSA",
      pos1: "President, PPSC",
      pos2: "PHILIPPINE PUBLIC SAFETY COLLEGE",
      pos3: "Lot 2 MWSS Compound, Katipunan Avenue",
      pos4: "admin.office@ppsc.gov.ph",

      department: "23 years old",
      plantillaNo: "Non-Binary",
      startDate: "09090990909",
      endDate: "May 30, 2023",
    },
  },
  {
    status: "Qualified",
    id: 2,
    dataset: {
      gender: "Male",
      workExp1: "Municipality of Bansalan",
      workExp2: "Office Staff",
      workExp3: "encode documents",
      workExp4: "paper works",
      workExp11: "KRZ Systems Incoporated",
      workExp21: "Technical Staff",
      workExp31: "take calls",
      workExp41: "troubleshoot",
      workExp51: "entertain client's concern/s",
      cs1: "PRC-ID",
      otherInfo:
        "Interested and qualified applicants should signify their interest in writing. Attach the following documents to the application letter and send to the address below not later than May 06, 2023",
      posTitle: "James Charles Uy",
      placeAssign: "Villa Donieza St.",
      address: "Tubod.",
      address1: "Bansalan",
      address2: "Davao Del Sur",
      elementary: "VILLA DONEZA CENTRAL ELEMENTARY SCHOOL",
      secondary: "MARBER NATIONAL HIGH SCHOOL",
      college: "SPAMAST ",
      salary: "19",
      monthlySalary: "Baha",
      eligibility: "RA. 1080",
      education: "Masters of Arts",
      training: "Five (5) years of relevant experience + VS Perfomance Rating",
      competency:
        "Delivering Efficient Results ? Personal Effectiveness ? Has  Community-Based Action Research and Published   Research ? Participated in Civic Welfare Service ? Proficient in Oral and Written Communication ? Teaching Skills ? Detailed Oriented ? Computer Literate",
      instruction:
        "Interested and qualified applicants should signify their interest in writing. Attach the following documents to the application letter and send to the address below not later than May 06, 2023.",
      document1:
        "1. Fully accomplished Personal Data Sheet (PDS) with recent passport-sized picture (CS Form No. 212, Revised 2017) which can be downloaded at www.csc.gov.ph;",
      document2:
        "2. Performance rating in the present position for one (1) year (if applicable);",
      document3:
        "3. Photocopy of certificate of eligibility/rating/license; and",
      document4: "4. Photocopy of Transcript of Records.",
      qualifiedApplicants:
        "are advised to hand in or send through courier/email their application to:",
      employerName: "PBGEN FERDINANDO G SEVILLA (Ret), MPSA",
      pos1: "President, PPSC",
      pos2: "PHILIPPINE PUBLIC SAFETY COLLEGE",
      pos3: "Lot 2 MWSS Compound, Katipunan Avenue",
      pos4: "admin.office@ppsc.gov.ph",

      department: "23 years old",
      plantillaNo: "Non-Binary",
      startDate: "09090990909",
      endDate: "May 30, 2023",
    },
  },

  {
    status: "Disqualified",
    id: 3,
    dataset: {
      gender: "Female",
      workExp1: "Municipality of Bansalan",
      workExp2: "Office Staff",
      workExp3: "encode documents",
      workExp4: "paper works",
      workExp11: "KRZ Systems Incoporated",
      workExp21: "Technical Staff",
      workExp31: "take calls",
      workExp41: "troubleshoot",
      workExp51: "entertain client's concern/s",
      cs1: "PRC-ID",
      otherInfo:
        "Interested and qualified applicants should signify their interest in writing. Attach the following documents to the application letter and send to the address below not later than May 06, 2023",
      posTitle: "Cheenita Shane Deyto",
      placeAssign: "Villa Donieza St.",
      address: "Tubod.",
      address1: "Bansalan",
      address2: "Davao Del Sur",
      elementary: "VILLA DONEZA CENTRAL ELEMENTARY SCHOOL",
      secondary: "MARBER NATIONAL HIGH SCHOOL",
      college: "SPAMAST ",
      salary: "19",
      monthlySalary: "Baha",
      eligibility: "RA. 1080",
      education: "Masters of Arts",
      training: "Five (5) years of relevant experience + VS Perfomance Rating",
      competency:
        "Delivering Efficient Results ? Personal Effectiveness ? Has  Community-Based Action Research and Published   Research ? Participated in Civic Welfare Service ? Proficient in Oral and Written Communication ? Teaching Skills ? Detailed Oriented ? Computer Literate",
      instruction:
        "Interested and qualified applicants should signify their interest in writing. Attach the following documents to the application letter and send to the address below not later than May 06, 2023.",
      document1:
        "1. Fully accomplished Personal Data Sheet (PDS) with recent passport-sized picture (CS Form No. 212, Revised 2017) which can be downloaded at www.csc.gov.ph;",
      document2:
        "2. Performance rating in the present position for one (1) year (if applicable);",
      document3:
        "3. Photocopy of certificate of eligibility/rating/license; and",
      document4: "4. Photocopy of Transcript of Records.",
      qualifiedApplicants:
        "are advised to hand in or send through courier/email their application to:",
      employerName: "PBGEN FERDINANDO G SEVILLA (Ret), MPSA",
      pos1: "President, PPSC",
      pos2: "PHILIPPINE PUBLIC SAFETY COLLEGE",
      pos3: "Lot 2 MWSS Compound, Katipunan Avenue",
      pos4: "admin.office@ppsc.gov.ph",

      department: "23 years old",
      plantillaNo: "Non-Binary",
      startDate: "09090990909",
      endDate: "May 30, 2023",
    },
  },
];
export default data1;
